<template>
  <div>
    <!-- Navigation Buttons (like SettingsLocations: locations / location groups) -->
    <div id="outer-container">
      <div ref="navButtons" class="card mar-bt-0 mar-to-10 max-z-index navButtons">
        <div class="card-content">
          <div class="clearfix row pad-lf-10 pad-rg-10">
            <a
              class="btn btn-fill btn-primary"
              :class="{ active: isZones }"
              @click="openTab('zones')"
            >{{ $t('deliveryPreferences.zonesTitle') }}</a>

            <a
              class="btn btn-fill btn-primary"
              :class="{ active: isSlots }"
              @click="openTab('slots')"
            >{{ $t('deliveryPreferences.slotsTitle') }}</a>

            <a
              class="btn btn-fill btn-primary"
              :class="{ active: isPreferences }"
              @click="openTab('preferences')"
            >{{ $t('deliveryPreferences.preferencesTitle') }}</a>
          </div>
        </div>
      </div>
    </div>

    <!-- Tab Contents -->
    <div v-if="isZones">
      <settings-delivery-zones></settings-delivery-zones>
    </div>

    <div v-if="isSlots">
      <settings-delivery-slots></settings-delivery-slots>
    </div>

    <div v-if="isPreferences">
      <settings-delivery-preferences></settings-delivery-preferences>
    </div>
  </div>
</template>
<script>
import SettingsDeliveryZones from './SettingsDeliveryZones.vue'
import SettingsDeliverySlots from './SettingsDeliverySlots.vue'
import SettingsDeliveryPreferences from './SettingsDeliveryPreferences.vue'

export default {
  components: {
    SettingsDeliveryZones,
    SettingsDeliverySlots,
    SettingsDeliveryPreferences
  },
  data () {
    return {
      isZones: true,
      isSlots: false,
      isPreferences: false
    }
  },
  methods: {
    openTab (tab) {
      this.isZones = false
      this.isSlots = false
      this.isPreferences = false

      switch (tab) {
        case 'zones':
          this.isZones = true
          break
        case 'slots':
          this.isSlots = true
          break
        case 'preferences':
          this.isPreferences = true
          break
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/DeliveryPreferences/SettingsDeliveryType.vue